/* We the Phillies — header behavior.
   Mobile nav drawer + cart drawer hand-off. Dawn's cart-drawer custom element
   owns the drawer itself; we only need to open it and keep the count in sync. */

(function () {
  var header = document.querySelector('[data-wtp-header]');
  if (!header) return;

  var toggle = header.querySelector('[data-wtp-nav-toggle]');
  var nav = header.querySelector('[data-wtp-nav]');
  var scrim = header.querySelector('[data-wtp-nav-scrim]');

  function setNav(open) {
    if (!nav || !toggle) return;
    nav.setAttribute('data-open', String(open));
    toggle.setAttribute('aria-expanded', String(open));
    if (scrim) scrim.hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      var first = nav.querySelector('a');
      if (first) first.focus();
    }
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      setNav(nav.getAttribute('data-open') !== 'true');
    });
  }

  if (scrim) {
    scrim.addEventListener('click', function () {
      setNav(false);
      if (toggle) toggle.focus();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && nav && nav.getAttribute('data-open') === 'true') {
      setNav(false);
      if (toggle) toggle.focus();
    }
  });

  // Reset the drawer when we cross back to desktop so state can't get stuck.
  var desktop = window.matchMedia('(min-width: 900px)');
  var onChange = function (event) {
    if (event.matches) setNav(false);
  };
  if (desktop.addEventListener) desktop.addEventListener('change', onChange);
  else desktop.addListener(onChange);

  // Open Dawn's cart drawer instead of navigating, when the drawer is enabled.
  var cartTrigger = header.querySelector('[data-wtp-cart-trigger]');
  if (cartTrigger) {
    cartTrigger.addEventListener('click', function (event) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || drawer.classList.contains('is-empty')) return;
      event.preventDefault();
      if (typeof drawer.open === 'function') drawer.open(cartTrigger);
    });
  }
})();
